/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';
import appConfig from '@bingads-webui-component-legacy/config/index';
import { StyledCampaignChooseObjective } from './choose-objective';

const chooseObjectiveViewPromise = () => Promise.resolve(props => (<StyledCampaignChooseObjective config={appConfig} {...props} />));


export const ChooseObjectiveWithLegacyConfig = withI18nConsumer((props) => {
  const ChooseObjectiveView = React.lazy(() => { // eslint-disable-line arrow-body-style
    return chooseObjectiveViewPromise(props).then(InjectedView => ({
      default: () => (<InjectedView {...props} />),
    }));
  });

  return (
    <React.Suspense fallback={<ProgressiveLoadingBlock />}>
      <ChooseObjectiveView />
    </React.Suspense>);
});
